export enum AdditionQuestionsEnum {
  // NewArrivedOrBookingDate = 'NewArrivedOrBookingDate',
  NewArrivedDate = 'NewArrivedDate'
}
